module.exports = __webpack_public_path__ + "img/we_need_you.248780ed.png";